import React from 'react'
import { Editor } from '@tinymce/tinymce-react'
import { globalReactService } from '@commons'
import { editorConfiguration } from './editor-configuration'

const { apiKeyTiny } = globalReactService
interface IWysiwyg {
  value: string
  onChange: (e: string) => void
}

const Wysiwyg: React.FC<IWysiwyg> = ({ value = '', onChange }) => {
  return (
    <Editor
      apiKey={apiKeyTiny}
      value={value}
      init={editorConfiguration()}
      onEditorChange={(e) => {
        onChange(e)
      }}
    />
  )
}

export default Wysiwyg
